import Marionette from 'backbone.marionette';
import core_layouts from '../../../../core/layouts';
import help_pages from '../../views/Help';
import { AdvertisingView } from '../../views';
import '../../styles/help-page.styl';
import { Model } from "backbone";
import WinnersFantasy from '../../collections/WinnersFantasy';
import { sizes_for_big_ad } from '../../../../core/utils';
import ZendeskFAQs from "../../collections/ZendeskFAQs";

export default class HelpController extends Marionette.Object {
	help() {

	}

	whatsNew() {
		const
			rootView        = this.getOption( 'rootView' ),
			fullWidthLayout = new core_layouts.FullWidth(),
			whatsNew        = new help_pages.WhatsNewView({
				model: new Model()
			});

		this.initAdvertisings( rootView );

		fullWidthLayout.getRegion( 'content' ).show( whatsNew );
		rootView.getRegion( 'main' ).show( fullWidthLayout );
	}

	faq() {
		const
			rootView        = this.getOption( 'rootView' ),
			fullWidthLayout = new core_layouts.FullWidth(),
			FAQs            = new help_pages.FAQsView({
				collection: new ZendeskFAQs(),
				model: new Model({
					faqsItems: [],
				})
			});

		this.initAdvertisings( rootView );

		fullWidthLayout.getRegion( 'content' ).show( FAQs );
		rootView.getRegion( 'main' ).show( fullWidthLayout );
	}

	contactUs() {
		const
			rootView           = this.getOption( 'rootView' ),
			rightSidebarLayout = new core_layouts.RightSidebar(),
			contactUs          = new help_pages.ContactUsView(),
			widgetsSidebar     = new core_layouts.WidgetsSidebar(),
			advertisingSidebar = new AdvertisingView( {
				'ad_id': 'league-manage-ad-slot-1',
				pos: 2,
			} );

		this.initAdvertisings( rootView );

		widgetsSidebar.getRegion( 'ads_container' ).show( advertisingSidebar );

		rightSidebarLayout.getRegion( 'content' ).show( contactUs );
		rightSidebarLayout.getRegion( 'sidebar' ).show( widgetsSidebar );

		rootView.getRegion( 'main' ).show( rightSidebarLayout );
	}

	guidelines() {
		const
			rootView        = this.getOption( 'rootView' ),
			fullWidthLayout = new core_layouts.FullWidth(),
			GameGuidelines  = new help_pages.GameGuidelinesView();

		this.initAdvertisings( rootView );

		fullWidthLayout.getRegion( 'content' ).show( GameGuidelines );
		rootView.getRegion( 'main' ).show( fullWidthLayout );
	}

	draftGuidelines() {
		const
			rootView        = this.getOption( 'rootView' ),
			fullWidthLayout = new core_layouts.FullWidth(),
			GameGuidelines  = new help_pages.DraftGameGuidelinesView();

		this.initAdvertisings( rootView );

		fullWidthLayout.getRegion( 'content' ).show( GameGuidelines );
		rootView.getRegion( 'main' ).show( fullWidthLayout );
	}
	prizes() {
		const
			rootView	=	this.getOption('rootView'),
			fullWidthLayout	=	new core_layouts.FullWidth(),
			winnersFantasy 	=	new WinnersFantasy();
		winnersFantasy.fetch({
			success: collection => {
				const prizesModel = new Model({
					winners: collection.toJSON()
				});
				const prizes = new help_pages.PrizesView({
					model: prizesModel
				});
				this.initAdvertisings(rootView);
				fullWidthLayout.getRegion('content').show(prizes);
				rootView.getRegion('main').show(fullWidthLayout);
			},
			error: (collection, response) => {
				console.error('Failed to fetch winners:', response);
			}
		});
	}

	termsAndConditions() {
		const
			rootView           = this.getOption( 'rootView' ),
			fullWidthLayout    = new core_layouts.FullWidth(),
			termsAndConditions = new help_pages.TermsAndConditionsView();

		this.initAdvertisings( rootView );

		fullWidthLayout.getRegion( 'content' ).show( termsAndConditions );
		rootView.getRegion( 'main' ).show( fullWidthLayout );
	}

	fantasyCoach() {
		const
			rootView           = this.getOption( 'rootView' ),
			fullWidthLayout    = new core_layouts.FullWidth(),
			termsAndConditions = new help_pages.FantasyCoachView();

		this.initAdvertisings( rootView );

		fullWidthLayout.getRegion( 'content' ).show( termsAndConditions );
		rootView.getRegion( 'main' ).show( fullWidthLayout );
	}

	initAdvertisings( rootView ) {
		const advertisingTop  = new AdvertisingView({
			ad_id: 'help-ad-slot-3',
			ad_path:'help',
			size: sizes_for_big_ad(),
			pos: 1,
		});

		rootView.getRegion( 'top_ads_container' ).show( advertisingTop );
	}
}